import React, { useState, useEffect } from "react";
import styles from "../styles/MyCharacters.module.css";
import common from "../styles/Common.module.css";
import useApi from "../hooks/useApi";
import MyCharactersGridItem from "../components/MyCharactersGridItem";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCharacters,
  deleteCharacter,
  updateCharacter,
} from "../reducers/characterSlice";

function MyCharacters() {
  const navigate = useNavigate();
  const { get, post } = useApi();

  const dispatch = useDispatch();
  const characters = useSelector((state) => state.characters.items);
  const status = useSelector((state) => state.characters.status);

  useEffect(() => {
    if (status === "idle") {
      dispatch(getCharacters({get}));
    }
  }, [status, dispatch, get]);

  const handleDelete = async (id) => {
    await post(`/webapp/characters/delete/${id}/`);
    dispatch(deleteCharacter(id));
  };

  const goToCharacter = (character = null) => {
    console.log(character)
    if (character) {
      navigate(`/character/${character.id}`);
    } else {
      navigate("/character/");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.categoryMenu}>
        <button className={`${styles.categoryButton} ${styles.selected}`}>
          Mine
        </button>
        <button className={styles.categoryButton}>Community</button>
        <button className={styles.categoryButton}>Favorites</button>
      </div>

      {characters === null ? (
        <div className={styles.loader}></div>
      ) : (
        <div className={styles.gridContainer}>
          <button
            className={common.addButton}
            onClick={() => goToCharacter(null)}
          >
            <p>+</p>
          </button>

          {characters.slice().map((item) => (
            <MyCharactersGridItem
              key={item.id}
              item={item}
              onClick={() => goToCharacter(item)}
              onDelete={() => handleDelete(item.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default MyCharacters;
